var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.29373 8.47059L10.6467 6.11765L11.1173 6.58823C11.3761 6.84706 11.7996 6.84706 12.0584 6.58823C12.3173 6.32941 12.3173 5.90588 12.0584 5.64706L7.35255 0.941176C7.09373 0.682353 6.6702 0.682353 6.41138 0.941176C6.15255 1.2 6.15255 1.62353 6.41138 1.88235L6.88197 2.35294L4.52902 4.70588C3.74785 5.48706 2.48667 5.48706 1.7055 4.70588L0.764319 5.64706L3.57373 8.45647L0.279613 11.7506L0.279614 12.6918H1.22079L4.51491 9.39765L7.35255 12.2353L8.29373 11.2941C7.51255 10.5129 7.51255 9.25176 8.29373 8.47059Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "97131/static/media/Pin.1661829d185215a1931490edcab5cfde.svg";
export { ForwardRef as ReactComponent };